import { PageRequest } from './page-request';

export class PageResponse {
  pageRequest?: PageRequest;
  list?: Array<any>;
  totalRows?: number;
  totalPages?: number;
}
